import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable, Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class MiddlemanService {
  // Subjects
  private notify = new Subject<any>()
  private notifysuperadmin = new Subject<any>()
  private notifysuperadminclear = new Subject<any>()
  private notifysuperadminchangeMenu = new Subject<any>()
  private notifytimeout = new Subject<any>()
  private notifyRefreshmenu = new Subject<any>()
  private notifynewUserSetup = new Subject<any>()
  private notifypageredirect = new Subject<any>()
  private notifypbranchnumberdirect = new Subject<any>()
  private roleSwitching = new BehaviorSubject<boolean>(false)

  //
  private notifyfilemanagerClosed = new Subject<any>()

  notifiyFilemgrObservable$ = this.notifyfilemanagerClosed.asObservable()
  // Behavior Subjects
  private marketingIdSubject: BehaviorSubject<number>
  notifiynewUserSetupObservable$ = this.notifynewUserSetup.asObservable()
  notifyObservable$ = this.notify.asObservable()
  notifyObservableSuper$ = this.notifysuperadmin.asObservable()
  notifyObservableSuperClear$ = this.notifysuperadminclear.asObservable()
  notifyObservablemenu$ = this.notifysuperadminchangeMenu.asObservable()
  marketingIdObservable$: Observable<number>
  notifytimeoutObservable$ = this.notifytimeout.asObservable()
  // Refresh menu
  notifymenuchangeObservable$ = this.notifyRefreshmenu.asObservable()
  // page Redirect
  notifyredirectObservable$ = this.notifypageredirect.asObservable()
  notifybarnchnumberObservable$ = this.notifypbranchnumberdirect.asObservable()
  roleSwitching$ = this.roleSwitching.asObservable()
  constructor() {
    const storedMarketingId = Number(sessionStorage.getItem('marketingId'))
    this.marketingIdSubject = new BehaviorSubject(storedMarketingId)
    this.marketingIdObservable$ = this.marketingIdSubject.asObservable()
  }
  public notifyFilemanagerWhenClose(v: boolean) {
    this.notifyfilemanagerClosed.next(v)
  }
  public notifyNewUserRedirect(r: boolean) {
    this.notifynewUserSetup.next(r)
  }
  public notifytimeClear() {
    this.notify.next(null)
  }
  public notifyClear(v: any) {
    this.notify.next(v)
  }
  public notifyClearWidthValue(v: any) {
    this.notify.next(v)
  }
  public notifysuperadminvalue(v: any) {
    this.notifysuperadmin.next(v)
  }
  public notifysuperadminvalueClear(v: boolean) {
    this.notifysuperadminclear.next(v)
  }
  public notifymenuchange(v: any) {
    this.notifysuperadminchangeMenu.next(v)
  }
  public updateMarketingIdSubject(marketingId: number) {
    sessionStorage.setItem('marketingId', marketingId.toString())
    this.marketingIdSubject.next(marketingId)
  }
  public notifyrefreshmenu() {
    this.notifyRefreshmenu.next(null)
  }
  public passroletodashboard(rolename: string) {
    this.notifypageredirect.next(rolename)
  }
  public Passbranchnumber(branchnuymber: string) {
    this.notifypbranchnumberdirect.next(branchnuymber)
  }
  public setRoleSwitching(switching: boolean) {
    this.roleSwitching.next(switching)
  }
}
